import React, { useState, useEffect } from 'react';
import './AvatarSelector.css';

const AvatarSelector = ({ selectedAvatar, onAvatarChange }) => {
  const [currentAvatar, setCurrentAvatar] = useState(selectedAvatar || '😊');

  const avatarOptions = [
    '😊', '😎', '🤖', '👾', '🎮', '⭐', '🔥', '💎', '🌟', '🎯',
    '⚡', '🌈', '🍀', '🎪', '🎨', '🎭', '🎪', '🎯', '🎲', '🎸'
  ];

  useEffect(() => {
    setCurrentAvatar(selectedAvatar || '😊');
  }, [selectedAvatar]);

  const handleAvatarChange = (avatar) => {
    setCurrentAvatar(avatar);
    onAvatarChange(avatar);
  };

  return (
    <div className="avatar-selector">
      <h3>Player Icon</h3>
      <div className="avatar-preview">
        <span className="avatar-display">{currentAvatar}</span>
        <span className="avatar-label">Your current icon</span>
      </div>
      <div className="avatar-grid">
        {avatarOptions.map((avatar, index) => (
          <button
            key={index}
            className={`avatar-option ${currentAvatar === avatar ? 'selected' : ''}`}
            onClick={() => handleAvatarChange(avatar)}
          >
            {avatar}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AvatarSelector;


